'use client';

import { useCallback, useEffect, useState } from 'react';

import { useNativeDataContext } from '@onyx/help-hub/hooks';
import { Button } from '@onyx/ui/components/colleague/button';
import { useSearchParams } from 'next/navigation';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { signIn as nextAuthSignIn } from 'next-auth/react';

import { useTeamsContext } from '../../utils/teams-context';
import { TeamsSignIn } from '../teams-sign-in/teams-sign-in';

export const SignIn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const searchParams = useSearchParams();
  const callbackUrl = searchParams?.get('callbackUrl') ?? '/';
  const { enabled: isNativeDataEnabled } = useNativeDataContext();
  const { isInTeams, isInitialized } = useTeamsContext();

  const performSignIn = useCallback(() => {
    const signInParams = {
      callbackUrl,
    };
    // We can't rely on the promise as it's an instant response, but takes a while to redirect
    void nextAuthSignIn('azure-ad', signInParams);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);
  }, [callbackUrl]);

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    if (isInTeams) {
      return;
    }

    if (isNativeDataEnabled) {
      performSignIn();
    }
  }, [performSignIn, isNativeDataEnabled, isInitialized, isInTeams]);

  if (!isInitialized) {
    return (
      <Button isLoading isDisabled>
        Detecting environment
      </Button>
    );
  }

  if (isInTeams) {
    return <TeamsSignIn callbackUrl={callbackUrl} />;
  }

  return (
    <Button
      isLoading={isLoading}
      isDisabled={isLoading}
      onClick={() => performSignIn()}
    >
      {isLoading ? 'Signing in' : 'Sign in via SSO'}
    </Button>
  );
};
